var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.314941,
    width: 77,
    height: 77,
    rx: 38.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0164 57.4961L30.9623 44.8975H58.7482L51.8017 57.4961H24.0164Z",
    fill: "#3777E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8558 44.8974H58.7483L44.8558 19.7002H30.9624L44.8558 44.8974Z",
    fill: "#FFCF63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0696 44.8974L24.0165 57.496L37.909 32.2988L30.9624 19.7002L17.0696 44.8974Z",
    fill: "#11A861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCircle);
export default __webpack_public_path__ + "static/media/driveCircle.8c733e82107e6d0b09bd61c7be716651.svg";
export { ForwardRef as ReactComponent };